/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ud_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free UUID and ULID inspector. Validate an identifier, see its version and variant, and decode the embedded timestamp. Runs in your browser.`)
};

const es_ud_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspector gratuito de UUID e ULID. Valida un identificador, ve su versión y variante, y decodifica la marca de tiempo incorporada. Se ejecuta en tu navegador.`)
};

const de_ud_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser UUID- und ULID-Inspector. Validieren Sie eine Kennung, sehen Sie deren Version und Variante, und decodieren Sie den eingebetteten Zeitstempel. Läuft direkt in Ihrem Browser.`)
};

const nl_ud_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis UUID en ULID inspector. Valideer een identificatie, bekijk de versie en variant en decodeer de ingebouwde tijdstempel. Werkt in je browser.`)
};

const fr_ud_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspecteur UUID et ULID gratuit. Validez un identifiant, consultez sa version et sa variante, et décodez l'horodatage intégré. S'exécute dans votre navigateur.`)
};

const it_ud_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ispettore gratuito di UUID e ULID. Convalida un identificatore, visualizza la sua versione e variante, e decodifica il timestamp incorporato. Funziona nel tuo browser.`)
};

const pt_br2_ud_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspetor gratuito de UUID e ULID. Valide um identificador, veja sua versão e variante, e decodifique o timestamp incorporado. Funciona no seu navegador.`)
};

const pt_ud_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspetor gratuito de UUID e ULID. Valide um identificador, veja a sua versão e variante e descodifique o timestamp incorporado. Funciona no seu navegador.`)
};

const ja_ud_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UUID と ULID の無料インスペクター。識別子を検証し、そのバージョンとバリアントを確認し、埋め込みタイムスタンプをデコードします。ブラウザで実行されます。`)
};

const zh_ud_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的 UUID 与 ULID 检查器。验证标识符,查看其版本和变体,并解码内嵌的时间戳。在浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ud_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ud_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ud_tool_description", locale)
	if (locale === "en") return en_ud_tool_description(inputs)
	if (locale === "es") return es_ud_tool_description(inputs)
	if (locale === "de") return de_ud_tool_description(inputs)
	if (locale === "nl") return nl_ud_tool_description(inputs)
	if (locale === "fr") return fr_ud_tool_description(inputs)
	if (locale === "it") return it_ud_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_ud_tool_description(inputs)
	if (locale === "pt") return pt_ud_tool_description(inputs)
	if (locale === "ja") return ja_ud_tool_description(inputs)
	return zh_ud_tool_description(inputs)
};